import { render, staticRenderFns } from "./ObiToolbar.vue?vue&type=template&id=8475eb24&scoped=true&"
import script from "./ObiToolbar.vue?vue&type=script&lang=js&"
export * from "./ObiToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ObiToolbar.vue?vue&type=style&index=0&id=8475eb24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8475eb24",
  null
  
)

export default component.exports